import styles from './footer.module.scss'

function Footer() {
    return (
        <div className={styles.footer}>
            <span>© ULMSOFT {new Date().getFullYear()}, ALL RIGHTS RESERVED</span>
            <div className={styles.links}>
                <a className={styles.link} href="mailto:tudor.ulmeanu@yahoo.com">tudor.ulmeanu@yahoo.com</a>
                <span className={styles.sep}>·</span>
                <a className={styles.link} href="https://www.ulmsoft.co.uk" target="_blank" rel="noreferrer">ulmsoft.co.uk</a>
            </div>
        </div>
    )
}

export default Footer;
